var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('debug-only',[_c('v-btn',{attrs:{"to":"/debug/trip"}},[_vm._v(" Trip ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }